import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, light = false }) => (
  <p
    className={`text-xs sm:text-sm tracking-[0.3em] uppercase font-sans font-medium ${
      light ? "text-ink-muted" : "text-gold"
    }`}
  >
    {children}
  </p>
);

export const SectionHead = ({ kicker, title, sub, light = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <Kicker light={light}>{kicker}</Kicker>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        className={`mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl leading-tight ${
          light ? "text-ink-dark" : "text-parchment-ivory"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className={`mt-5 text-base leading-relaxed ${light ? "text-ink-muted" : "text-parchment-ivory/70"}`}>
          {sub}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.25}>
      <div className={`gold-line mt-8 w-40 ${align === "center" ? "mx-auto" : ""}`} />
    </Reveal>
  </div>
);

export const GoldButton = ({ children, onClick, className = "", type = "button", ...rest }) => (
  <button
    type={type}
    onClick={onClick}
    className={`group relative inline-flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3 text-sm font-semibold tracking-wide text-ink-dark transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_25px_rgba(197,155,39,0.35)] ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, onClick, className = "", ...rest }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-gold/40 px-7 py-3 text-sm font-semibold tracking-wide text-gold-shimmer transition-colors duration-300 hover:border-gold-shimmer hover:bg-gold/10 ${className}`}
    {...rest}
  >
    {children}
  </button>
);
